// extracted by mini-css-extract-plugin
export default {"container":"Insights_container__zWAPU","header":"Insights_header__Gk7eU","inner":"Insights_inner__oOGLL","heroInner":"Insights_heroInner__8Meaj"};